import { buildHQLQueryFromFilters } from '../buildHQLQueryFromFilters';
import { Filter } from '../buildHQLQueryFromFilters/buildHQLQueryFromFilters';
import { buildHQLQueryFromString } from '../buildHQLQueryFromString';

export const buildSimpleSearchQuery = (
  query: string | null,
  filters: Filter[] = [],
): string => {
  const contact = buildHQLQueryFromString(query);
  const filter = buildHQLQueryFromFilters(filters);
  const delimeter = filter.length && contact.length ? ' AND ' : '';

  return `${delimeter !== '' ? `(${contact})` : contact}${delimeter}${filter}`;
};
